/* eslint-disable no-unused-vars */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import _ from 'lodash';
import { useFormValidationToast } from '../../../services/actionToast';
import { useFetch } from '../../../hooks/useFetch';
import { TextAreaInputForm } from '../../inputs/forms/TextAreaInputForm';
import { FormActions, FormSection, FormShell } from '../../ui';

interface TermsFormProps {
  defaultValues?: any;
}

interface FormInputsProps {
  name: string;
  value: string;
  placeholder?: string;
  label: string;
  yup: any;
}

export default function TermsForm({ defaultValues = {} }: TermsFormProps) {
  const validationToast = useFormValidationToast();
  const baseUrl = '/v1/admin/globals';
  const { requestApi } = useFetch(baseUrl);
  const yupschema: any = {};
  const defaultValuesSchema: any = {};

  const formInputs: FormInputsProps[] = [
    {
      name: 'term_condition',
      value: defaultValues.term_condition ?? '',
      placeholder: '',
      label: 'Descrição',
      yup: Yup.string(),
    },
  ];

  formInputs.forEach((object) => {
    yupschema[object.name] = object.yup;
    defaultValuesSchema[object.name] = object.value;
  });
  const schema = Yup.object().shape(yupschema);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: defaultValuesSchema,
  });

  const termCondition = formInputs.find((field) => field.name === 'term_condition');

  const onSubmit = async (values: any) => {
    const params = {
      ...defaultValues,
      ...values,
      logo: _,
    };
    await requestApi('put', params);
  };

  useEffect(() => {
    if (defaultValues.term_condition) {
      reset(defaultValuesSchema);
    }
  }, [defaultValues]);

  return (
    <FormShell title="Termos de Uso" description="Texto exibido aos usuários no aceite dos termos.">
      <Box
        as="form"
        noValidate
        onSubmit={handleSubmit(onSubmit, validationToast)}
        display="flex"
        flexDirection="column"
        gap="16px"
      >
        <FormSection title="Dados Básicos">
          <TextAreaInputForm
            name={termCondition?.name}
            label={termCondition?.label}
            placeholder={termCondition?.placeholder}
            errors={errors}
            register={register}
          />
        </FormSection>

        <FormActions isLoading={isSubmitting} />
      </Box>
    </FormShell>
  );
}
